/**
 * Mixin to house specific functionality for BARBRI's mobile application.
 */

import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('player', [
      'isBarbri',
      'isWebview',
    ]),
    runningInBarbriApp() {
      return this.isBarbri && this.isWebview;
    },
  },
  methods: {
    handleBarbriAppDownloadLinks() {
      const updatedInteractionText = document.createElement('div');
      updatedInteractionText.innerHTML = this.interaction.interactionText;
      for (const link of updatedInteractionText.querySelectorAll('a')) {
        if (link.href.includes('fastio')) link.remove();
      }
      this.interaction.interactionText = updatedInteractionText.innerHTML;
      updatedInteractionText.remove();
    }
  }
};
